<template>
  <div :class="['cityBlock', { cityBlock__header: header }]">
    <CustomSelect
      :options="cities || []"
      label=""
      placeholder="Выберите город"
      optionValueKey="city_id"
      optionLabelKey="city_name"
      :value="userData?.city_id || ''"
      :clearable="false"
      :autoHeight="true"
      :whiteMode="header"
      @change="handleChangeCity"
    />
    <q-space v-if="!header" style="margin-bottom: 10px;" />
  </div>
</template>

<script setup>
import { useAppStore } from '@/services/store/app'
import { storeToRefs } from 'pinia'
import CustomSelect from '@/components/form/CustomSelect'

const props = defineProps({
  header: { type: Boolean, default: false }
})

const appStore = useAppStore()
const { chooseCityData } = appStore
const { userData, cities } = storeToRefs(appStore)

const handleChangeCity = async (city_id) => {
  await chooseCityData(city_id)
}
</script>

<style scoped lang="scss">
.cityBlock {
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
  &__header {
    display: block;
    width: 250px;
    height: 35px;
    @media (max-width: 768px) {
      display: none;
    }
  }
}
</style>
